/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Before_LabelInputs */

const en_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before:`)
};

const fr_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant :`)
};

const de_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor:`)
};

const it_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima:`)
};

const ru_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До:`)
};

const es_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes:`)
};

const zh_cn2_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前：`)
};

const ja_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前に：`)
};

const hi_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले:`)
};

const pt_pt2_compare_event_groups_before_label = /** @type {(inputs: Compare_Event_Groups_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes:`)
};

/**
* | output |
* | --- |
* | "Before:" |
*
* @param {Compare_Event_Groups_Before_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_before_label = /** @type {((inputs?: Compare_Event_Groups_Before_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Before_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_before_label(inputs)
	if (locale === "de") return de_compare_event_groups_before_label(inputs)
	if (locale === "it") return it_compare_event_groups_before_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_before_label(inputs)
	if (locale === "es") return es_compare_event_groups_before_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_before_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_before_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_before_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_before_label(inputs)
	return en_compare_event_groups_before_label(inputs)
});